import script from "./baseCheckbox.vue?vue&type=script&setup=true&lang=js"
export * from "./baseCheckbox.vue?vue&type=script&setup=true&lang=js"

import "./baseCheckbox.vue?vue&type=style&index=0&id=4c93a639&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c93a639"]])

export default __exports__